"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCurrentVersion = exports.getCurrentVersion = void 0;
let moduleVersion = "3.14.14";
const getCurrentVersion = () => moduleVersion;
exports.getCurrentVersion = getCurrentVersion;
const setCurrentVersion = version => {
  moduleVersion = version;
};
exports.setCurrentVersion = setCurrentVersion;
//# sourceMappingURL=version.js.map